// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__+2WD0","normalXl":"styles_normalXl__t7yh0","normalLg":"styles_normalLg__+QxQ3","normalMd":"styles_normalMd__s2CLf","normalSm":"styles_normalSm__561cu"};